import { Box, CircularProgress, Fade, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LoadingOverlayProps = {
  loading: boolean;
  message?: string;
};

const LoadingOverlay = (props: LoadingOverlayProps) => {
  const { loading, message = 'statusMessages.loading' } = props;
  const { t } = useTranslation(['common']);
  return (
    <Fade in={loading}>
      <Box
        sx={{
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: 'absolute',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          zIndex: 200,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(2px)',
        }}
      >
        <Typography
          variant='h4'
          gutterBottom
          sx={{
            textShadow: '1px 1px 15px #ffffff, 0 0 5px #ffff, 0 0 25px #ffff, 0 0 10px #ffff',
          }}
          ara-live='polite'
          aria-busy='true'
        >
          {t(`${message}`)}
        </Typography>
        <CircularProgress />
      </Box>
    </Fade>
  );
};

export default LoadingOverlay;
